import React, { useState, useContext, useEffect } from "react";
import { MainContext } from "../../../Context/MainContext";

import SwiperCore, { Pagination, Navigation, Lazy } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import CarouselSlide from "./CarouselSlide";
import UilAngleRight from "@iconscout/react-unicons/icons/uil-angle-right";
import UilAngleLeft from "@iconscout/react-unicons/icons/uil-angle-left";

SwiperCore.use([Pagination, Navigation, Lazy]);

const ImageCarousel = ({ images }) => {
  const { MainState, gaEvent } = useContext(MainContext);

  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    if (swiper !== null) {
      swiper.update();
      swiper.slideTo(0, 0);
    }
  }, [JSON.stringify(MainState.filteredSpecials) + MainState.currentPage]);

  const params = {
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 0,
  };

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const PrevButton = () => {
    return (
      <div className="d-none d-md-flex align-items-center pb-4 position-absolute h-100 top-0 left-0 z-1 w-14 swiper-button-prev">
        <button
          onClick={() => goPrev()}
          className="d-flex align-items-center justify-content-center border-0 p-0 ml-2 mt-4 rounded-circle carousel-nav-btn"
        >
          <div className="text-dark d-flex">
            <UilAngleLeft size="22" fill="currentColor" />
          </div>
        </button>
      </div>
    );
  };

  const NextButton = () => {
    return (
      <div className="d-none d-md-flex align-items-center justify-content-end pb-4 position-absolute h-100 top-0 right-0 z-1 w-14 swiper-button-next">
        <button
          onClick={() => goNext()}
          className="d-flex align-items-center justify-content-center border-0 p-0 mr-2 mt-4 rounded-circle carousel-nav-btn"
        >
          <div className="text-dark d-flex">
            <UilAngleRight size="22" fill="currentColor" />
          </div>
        </button>
      </div>
    );
  };

  const handleSlideChange = ({ activeIndex, previousIndex }) => {
    var dir = activeIndex > previousIndex ? "next" : "prev";
    gaEvent("swiper", dir, activeIndex.toString());
  };

  return (
    <Swiper
      className="pb-4"
      onSwiper={setSwiper}
      onSlideChange={(swiper) => handleSlideChange(swiper)}
      lazy={{ loadPrevNext: true }}
      {...params}
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx}>
          <CarouselSlide image={img} />
        </SwiperSlide>
      ))}
      {PrevButton()}
      {NextButton()}
      <div className="swiper-pagination bottom-0"></div>
    </Swiper>
  );
};

export default ImageCarousel;
